const FormatQuote = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="m240-240 80-160H200q-33 0-56.5-23.5T120-480v-160q0-33 23.5-56.5T200-720h160q33 0 56.5 23.5T440-640v240q0 33-23.5 56.5T360-320H240Zm400 0 80-160H600q-33 0-56.5-23.5T520-480v-160q0-33 23.5-56.5T600-720h160q33 0 56.5 23.5T840-640v240q0 33-23.5 56.5T760-320H640Z"/>
        </svg>
    )
}

export default FormatQuote;

